export interface ITabs {
    setActive: (category: string) => void;
}

export class Tabs implements ITabs {
    active: string;

    constructor(activeTabName: string) {
        this.setActive(activeTabName);
    }

    setActive(category: string): void {
        this.active = category;
    }
}
